import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '../../components/ui/Modal.jsx'
import Button from '../../components/ui/Button.jsx'
import { Field, Input, Select } from '../../components/ui/Field.jsx'
import { useCountries } from '../../lib/useCountries.js'
import api from '../../lib/api.js'

/* Create/edit a company (admin) — POST/PUT /admin/companies. */
const empty = { name: '', country_code: 'BE', vat_number: '', address: '', postal_code: '', city: '', email: '', phone: '', is_active: true, setup_completed: false }

export default function CompanyFormModal({ company, onClose, onSaved }) {
  const { t } = useTranslation()
  const countries = useCountries()
  const isEdit = !!company
  const [f, setF] = useState(company ? { ...empty, ...company } : empty)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }))

  const submit = async (e) => {
    e.preventDefault()
    setSaving(true); setError('')
    const payload = { ...f, country_code: (f.country_code || '').toUpperCase().slice(0, 2) }
    try {
      if (isEdit) await api.put(`/admin/companies/${company.id}`, payload)
      else await api.post('/admin/companies/', payload)
      onSaved()
    } catch (e2) { setError(e2?.response?.data?.error || t('admin.errorGeneric')) } finally { setSaving(false) }
  }

  return (
    <Modal open onClose={onClose} maxWidth={560} closeOnBackdrop={false}>
      <form onSubmit={submit} style={{ padding: 24 }}>
        <h3 style={{ fontFamily: 'var(--font-title)', fontWeight: 700, fontSize: 18, marginBottom: 16 }}>{isEdit ? t('admin.companies.edit') : t('admin.companies.new')}</h3>
        {error && <div role="alert" style={{ background: 'var(--color-danger-bg)', color: 'var(--color-danger)', border: '1px solid #f3c9c9', borderRadius: 10, padding: '9px 12px', fontSize: 13, marginBottom: 14 }}>{error}</div>}
        <Field label={t('admin.companies.name')} required><Input value={f.name} onChange={(e) => set('name', e.target.value)} required /></Field>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 14 }}>
          <Field label={t('admin.companies.vat')}><Input value={f.vat_number} onChange={(e) => set('vat_number', e.target.value)} placeholder="BE0123456789" /></Field>
          <Field label={t('admin.companies.country')} required>
            <Select value={f.country_code} onChange={(e) => set('country_code', e.target.value)}>{countries.map((c) => <option key={c.code} value={c.code}>{c.code}</option>)}</Select>
          </Field>
        </div>
        <Field label={t('parties.fields.address')}><Input value={f.address} onChange={(e) => set('address', e.target.value)} /></Field>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 14 }}>
          <Field label={t('parties.fields.postalCode')}><Input value={f.postal_code} onChange={(e) => set('postal_code', e.target.value)} /></Field>
          <Field label={t('parties.fields.city')}><Input value={f.city} onChange={(e) => set('city', e.target.value)} /></Field>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          <Field label="Email"><Input type="email" value={f.email} onChange={(e) => set('email', e.target.value)} /></Field>
          <Field label={t('parties.fields.phone')}><Input value={f.phone} onChange={(e) => set('phone', e.target.value)} /></Field>
        </div>
        <div style={{ display: 'flex', gap: 20, margin: '4px 0 16px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13.5 }}><input type="checkbox" checked={f.is_active} onChange={(e) => set('is_active', e.target.checked)} /> {t('admin.active')}</label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13.5 }}><input type="checkbox" checked={f.setup_completed} onChange={(e) => set('setup_completed', e.target.checked)} /> {t('admin.companies.setupDone')}</label>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <Button type="button" variant="secondary" onClick={onClose}>{t('common.cancel')}</Button>
          <Button type="submit" variant="primary" icon="check" loading={saving}>{t('common.save')}</Button>
        </div>
      </form>
    </Modal>
  )
}
